/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { i as initialize } from './ionic-global-ca86cf32.js';

const globalScripts = initialize;

export { globalScripts as g };
